import templateUrl from 'emun.salesrep/salesrep-sales-goals-vendor.htm';
import salesrepConfig from 'emun.salesrep/salesrep.config'

class SalesRepSalesGoalsVendorController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery) {
		let $ctrl = this;
		$ctrl.orderByField = 'label';
		$ctrl.reverseSort = false;
		$ctrl.mode = "list";
		$ctrl.total = 0;
		$ctrl.repGroupFilter = '';
		$ctrl.label = $ctrl.title || "Vendor";
		if ($ctrl.repGroup !== 'ALL') {
			$ctrl.repGroupFilter = '&RepGroupName=' + $ctrl.repGroup;
		}
		$ctrl.colors = salesrepConfig.chartColors;
		$ctrl.chartOptions = {
			maintainAspectRatio: false,
			legend: {
				display: true,
				labels: {
					boxWidth: 5,
					fontSize: 10
				}
			},
			elements: {
				rectangle: {
					borderWidth: 1
				}
			},
			tooltips: {
				enabled: true,
				callbacks: {
					label: function (tooltipItem, data) {
						var label = data.labels[tooltipItem.index];
						let datasetLabel = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
						return label + ": $" + datasetLabel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "  (" + Math.round(((datasetLabel / $ctrl.total) * 100)) + '%)';
					}
				}
			}
		};
		var context = $ctrl.context || 'rep';

		var filter = "SalesRepID";
		if (context === 'manager') { filter = "ManagerId"; }
		if (context === 'vendor') { filter = "VendorId"; }
		if ($ctrl.context === 'executive') { filter = ''; }

		$ctrl.results = [];

		var salesQueryUrl = 'QuerySalesYOYTotals.json?Sum=TotalSalesMonthToDate,TotalSalesQuarterToDate,TotalSalesYearToDate,TotalSalesMonthToDateLastYear,TotalSalesQuarterToDateLastYear,TotalSalesYearToDateLastYear,TotalSalesLastYear,TotalSalesCountYearToDate,TotalSalesCountLastYear,TotalSalesCountYearToDateLastYear&GroupBy=VendorID,VendorName&OrderBy=VendorName';
		if ($ctrl.repGroup) {
			if ($ctrl.repGroup !== 'ALL') {
				salesQueryUrl = salesQueryUrl + '&RepGroupName=' + $ctrl.repGroup;
			}
		}
		if (context === 'writingRep') {
			if ($ctrl.salesRepId) {
				salesQueryUrl = salesQueryUrl + '&SalesRepID=' + $ctrl.salesRepId;
				filter = '';
			}
			else {
				if ($ctrl.writingRepId) {
					salesQueryUrl = salesQueryUrl + '&WritingRepID=' + $ctrl.writingRepId;
					filter = '';
				}
			}
		}
		else {
			if (filter !== '') {
				salesQueryUrl = salesQueryUrl + '&' + filter + '=' + $ctrl.rep.id;
			}
		}
		if ($ctrl.insideSales === 'true') {
			salesQueryUrl = salesQueryUrl + '&IsInsideSales=true';
		}

		$ctrl.salesQuery = createAutoQuery({
			url: salesQueryUrl,
			pageSize: 1000,
			autoLoad: false,
			onLoaded: function (args) {
				$ctrl.chartLabels = [];
				$ctrl.chartData = [];
				$ctrl.ytdTotal = 0;
				$ctrl.ytdTotalCount = 0;
				$ctrl.lastytdTotal = 0;
				$ctrl.lastytdTotalCount = 0;
				$ctrl.lyTotal = 0;
				$ctrl.lyTotalCount = 0;
				$ctrl.mtdTotal = 0;
				$ctrl.lastmtdTotal = 0;
				$ctrl.totalYearGoal = 0;
				$ctrl.totalMonthGoal = 0;

				args.results.forEach(function (sales) {
					if (sales.sumTotalSalesYearToDate > 0) {
						$ctrl.ytdTotal += sales.sumTotalSalesYearToDate;
					}
					if (sales.sumTotalSalesYearToDateLastYear > 0) {
						$ctrl.lastytdTotal += sales.sumTotalSalesYearToDateLastYear;
					}
					if (sales.sumTotalSalesLastYear > 0) {
						$ctrl.lyTotal += sales.sumTotalSalesLastYear;
					}
					if (sales.sumTotalSalesMonthToDate > 0) {
						$ctrl.mtdTotal += sales.sumTotalSalesMonthToDate;
					}
					if (sales.sumTotalSalesMonthToDateLastYear > 0) {
						$ctrl.lastmtdTotal += sales.sumTotalSalesMonthToDateLastYear;
					}
				});
				args.results.forEach(function (sales) {
					$ctrl.vendors.results.forEach(function (v) {
						if (sales.vendorName === v.label) {
							v.vendorID = sales.vendorID;
							v.ytdTotal = sales.sumTotalSalesYearToDate;
							v.ytdTotalCount = sales.sumTotalSalesCountYearToDate;
							v.lastytdTotal = sales.sumTotalSalesYearToDateLastYear;
							v.lastytdTotalCount = sales.sumTotalSalesCountYearToDateLastYear;
							v.lyTotal = sales.sumTotalSalesLastYear;
							v.lyTotalCount = sales.sumTotalSalesCountLastYear;
							v.mtdTotal = sales.sumTotalSalesMonthToDate;
							v.lastmtdTotal = sales.sumTotalSalesMonthToDateLastYear;
							v.monthGoal = 0;
							v.goal = 0;
							v.ytdGoal = 0;
							v.percent = 0;
							v.ytdVendorPercent = 0;
							v.lastytdVendorPercent = 0;
							v.lyVendorPercent = 0;
							v.tylyVendorPercent = 0;
							v.TYLYDollarDiff = 0;
							v.TYAverage = 0;
							v.LYAverage = 0;
							v.ytdVendorPercent = Math.round((v.ytdTotal / $ctrl.ytdTotal) * 100);
							v.lastytdVendorPercent = Math.round((v.lastytdTotal / $ctrl.lastytdTotal) * 100);
							v.lyVendorPercent = Math.round((v.lyTotal / $ctrl.lyTotal) * 100);

							v.TYAverage = v.ytdTotal / v.ytdTotalCount;
							v.LYAverage = v.lyTotal / v.lyTotalCount;
							v.LYTDAverage = v.lastytdTotal / v.lastytdTotalCount;
							if (v.lyTotal == 0 && v.ytdTotal > 0) {
								v.tylyVendorPercent = v.ytdTotal;
							} else if (v.lyTotal > 0 && v.ytdTotal == 0) {
								v.tylyVendorPercent = 0;
							} else {
								v.tylyVendorPercent = Math.round((v.ytdTotal / v.lyTotal) * 100);
							}

							v.TYLYDollarDiff = v.ytdTotal - v.lyTotal;
							$ctrl.chartLabels.push(v.label);
							$ctrl.chartData.push(Math.round(v.ytdTotal));
							$ctrl.total += v.ytdTotal;
						}
					});
				});
				var salesGoalsUrl = 'QuerySalesRepGoals.json?Sum=SalesGoalThisMonth,SalesGoalThisYear,SalesGoalLastYear,SalesGoalLastMonth&GroupBy=VendorName&OrderBy=VendorName';
				if ($ctrl.repGroup) {
					if ($ctrl.repGroup !== 'ALL') {
						salesGoalsUrl = salesGoalsUrl + '&RepGroupName=' + $ctrl.repGroup;
					}
				}
				//if (filter !== '') {
				//  salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
				//}
				if (context !== 'writingRep' && context !== 'executive') {
					if (filter !== '') {
						salesGoalsUrl = salesGoalsUrl + '&' + filter + '=' + $ctrl.rep.id;
					}
				}
				else {
					if ($ctrl.writingRepId) {
						salesGoalsUrl = salesGoalsUrl + '&WritingRep=' + $ctrl.writingRepId;
					}
				}
				if ($ctrl.insideSales === 'true') {
					// salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=true';
				}
				else {
					salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=false';
				}

				if ((context === 'writingRep') || ($ctrl.insideSales === 'true')) {
					//do nothing because we have no goals per vendor for inside sales
				}
				else //standard
				{

					$ctrl.salesGoals = createAutoQuery({
						url: salesGoalsUrl,
						autoLoad: true,
						pageSize: 1000,
						onLoaded: function (args) {

							args.results.forEach(function (goals) {
								$ctrl.vendors.results.forEach(function (vendor, index) {
									if (vendor.ytdTotal > 0 && vendor.label === goals.vendorName) {
										//console.info("vendorInfo", vendor.label, vendor.ytdTotal, goals.sumSalesGoalThisYear);
										vendor.goal = goals.sumSalesGoalThisYear || 0;
										vendor.monthGoal = goals.sumSalesGoalThisMonth || 0;
										if (vendor.goal > 0) {
											vendor.percent = Math.round((vendor.ytdTotal / vendor.goal) * 100);
										} else {
											vendor.percent = 0;
										}
										$ctrl.totalYearGoal += vendor.goal;
										$ctrl.totalMonthGoal += vendor.monthGoal;
									}
								});
							});

							//remove empty records
						}
					});
				}
				$ctrl.isBusy = false;
			}
		});

		$ctrl.isBusy = true;
		var vendorUrl = '';
		if ($ctrl.repGroup) {
			if ($ctrl.repGroup !== 'ALL' && salesrepConfig.limitVendorByRepGroup) {
				vendorUrl = '&RepGroupName=' + $ctrl.repGroup;
			}
		}
		$ctrl.vendors = createAutoQuery({
			url: 'QueryVendorList.json?Active=1&IdNotIn=999' + vendorUrl,
			orderBy: 'Label',
			pageSize: 1000,
			autoLoad: true,
			onLoaded: function (vendors) {
				$ctrl.salesQuery.load(true);
			}
		});
	}
}

let SalesRepSalesGoalsVendor = {
	bindings: {
		rep: '<',
		repGroup: '@',
		context: '@',
		title: '@',
		insideSales: '@',
		writingRepId: '@',
		salesRepId: '@'
	},
	controller: SalesRepSalesGoalsVendorController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default SalesRepSalesGoalsVendor